import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/facturacion/facturaFarmFEL';
import FacturaB from './FacturaBienesTabs';


const ms2p = (state) => {
  return {
    ...state.factura_farm_fel,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(FacturaB);
